import './buttonCreateNew.less'
import { ACTIONS } from '../PermissionMapper/constants'
import { ProtectedContent } from '../../HOCs/ProtectedContent'
import { Button, ButtonProps } from '@lightbeamai/design-system'
import React from 'react'

interface IProps {
  title: string
  onClick?: () => void
  to?: string
  action?: ACTIONS
  className?: string
  variant?: ButtonProps['variant']
  size?: ButtonProps['size']
}
const ButtonCreateNew = ({
  title,
  to = '',
  className = '',
  action,
  onClick,
  variant = 'primary',
  size = 32
}: IProps): React.ReactElement => {
  const handleClick = (e) => {
    if (onClick) {
      e.stopPropagation()
      e.preventDefault()
      onClick()
    }
  }

  const button = (
    <Button
      variant={variant}
      className={`button-create-new ${className}`}
      onClick={handleClick}
      data-test-id="btn-create-new"
      size={size}
      href={to}
    >
      <span className="title">{title}</span>
    </Button>
  )

  return action ? <ProtectedContent actions={[action]}>{button}</ProtectedContent> : button
}

export default ButtonCreateNew
